<button
  class="month-selector-previous z-[1]"
  type="button"
  appUiButton
  appearance="outline"
  size="header"
  surface="header"
  shape="joinedStart"
  iconOnly
  [disabled]="currentMonthYear() <= ((startMonthYear$ | async) ?? '')"
  (click)="previousMonth()"
  aria-label="select previous month"
>
  <app-ui-icon name="chevron-left" />
</button>
<button
  class="month-selector-toggle w-month-toggle min-w-month-toggle"
  type="button"
  appUiButton
  appearance="outline"
  size="header"
  surface="header"
  shape="joinedMiddle"
  (click)="todaysMonth()"
>
  {{ month.formatMonthYear(currentMonthYear()) }}
</button>
<button
  class="month-selector-next"
  type="button"
  appUiButton
  appearance="outline"
  size="header"
  surface="header"
  shape="joinedEnd"
  iconOnly
  (click)="nextMonth()"
  aria-label="select next month"
>
  <app-ui-icon name="chevron-right" />
</button>
